import * as React from 'react'
import { Boxes as AssetIcon, Network as SegmentIcon, Router as DeviceIcon } from 'lucide-react'
import type { PlantNetworkNodeKind } from '@axilon-apps/domains-ontology-ui-state'

type IconComponent = React.ComponentType<{ size?: number | string; className?: string }>

/**
 * Lucide icon assignments per Network node kind (Experion EMDB
 * enterprise / PCN). Used by both the left-rail tree and the right-pane
 * detail header.
 */
const ICONS_BY_KIND: Record<PlantNetworkNodeKind, IconComponent> = {
  Asset: AssetIcon,
  NetworkSegment: SegmentIcon,
  NetworkDevice: DeviceIcon
}

export function networkIconFor(kind: PlantNetworkNodeKind): IconComponent {
  return ICONS_BY_KIND[kind]
}

const SINGULAR_LABELS: Record<PlantNetworkNodeKind, string> = {
  Asset: 'Asset',
  NetworkSegment: 'Network segment',
  NetworkDevice: 'Network device'
}

export function networkLabelFor(kind: PlantNetworkNodeKind): string {
  return SINGULAR_LABELS[kind]
}
